__turbopack_context__.v({
  "className": "gochi_hand_df100fec-module___xM8BG__className",
});
